import { ReactNode, useState } from 'react';
import {
  StyledSectionHeading,
  StyledSectionHeadingTitle,
  StyledPopoverContent,
  StyledSubtitle1,
} from 'modules/ai/nba/components/card/CardHeader.styles';
import { PopoverTrigger, Popover, DefaultTriggerIcon } from 'ui/popover';

interface CardHeaderProps {
  icon: JSX.Element;
  title: string;
  popoverContent: ReactNode | string;
  popoverContentTitle?: string;
  popoverLinkContent?: ReactNode;
}

export const CARD_HEADER_DATA_TEST_ID = 'card-header';

export const CardHeader = ({
  title,
  icon,
  popoverContent,
  popoverContentTitle,
  popoverLinkContent,
}: CardHeaderProps) => {
  const [popoverOpen, togglePopoverOpen] = useState(false);

  return (
    <StyledSectionHeadingTitle data-test={CARD_HEADER_DATA_TEST_ID}>
      <div>{icon}</div>
      <StyledSectionHeading>
        <StyledSubtitle1>{title}</StyledSubtitle1>
        <div>
          <Popover onOpenChange={togglePopoverOpen}>
            <StyledPopoverContent
              TitleContent={popoverContentTitle}
              LinkContent={popoverLinkContent}
              side={'top'}
            >
              {popoverContent}
            </StyledPopoverContent>
            <PopoverTrigger
              Icon={({ ...props }) => <DefaultTriggerIcon height={16} width={16} {...props} />}
              isOpen={popoverOpen}
            />
          </Popover>
        </div>
      </StyledSectionHeading>
    </StyledSectionHeadingTitle>
  );
};
